﻿import { store } from '@redux/store';
import GoogleAnalyticsEvent from 'dataTransferObjects/googleAnalyticsEvent';
import uiStateSlice from 'layout/redux/uiStateSlice';
import modalService from 'layout/services/modalService';
import { closeModalSvg, 
  thankYouEmail,
  thankYouHeart,
  thankYouPhone,
  thankYouSuccess 
 } from '../constants/svgIcons';

export default class ThankScreenComingSoon {
  constructor() {
    const state = store.getState();
    const modalInformation = state?.uiState?.modalInformation;
    const listingInformation = modalInformation?.listingInformation;

    this.url = modalInformation?.url;
    this.schedulerUrl = listingInformation?.schedulerUrl;
    this.hasCallTracking = listingInformation?.hasCallTracking === "True";
    this.phoneNumber = listingInformation?.phoneNumber;
    this.builderName = listingInformation?.brandName ?? 'the builder';
    this.marketId = listingInformation?.marketId;
    this.closeAttribute = '[data-close]';
    this.closeBtnId = 'closeBtn';
  }

  emitMoreDetailsClickEvent() {
    const googleAnalyticsDTO = new GoogleAnalyticsEvent('Card-Clicks', 'SRP-Card-Clicks', this.url);
    store.dispatch(uiStateSlice.actions.trackUserEvent({ googleAnalyticsDTO }));
  }

   /**
   * Sets the contact builder anchor for the ThankScreenBrochure component.
   * @param {object} anchor - The anchor to be set (SchedulerAnchor, PhoneAnchorCallTracking or PhoneAnchor).
   */
   setContactBuilderAnchor(anchor) {
    this.contactBuilderAnchor = anchor;
  }

   /**
   * Sets the internal browsing anchor for the ThankScreenBrochure component.
   * @param {object} anchor - The anchor to be set (CreateAccountAnchor or ReturnToSearchAnchor).
   */
   setInternalBrowsingAnchor(anchor) {
    this.internalBrowsingAnchor = anchor;
  }

  /**
   * Binds events to the ThankScreenBrochure component.
   * @function bindEvents
   * @memberof ThankScreenBrochure
   * @instance
   */
  bindEvents() {
    const closeElements = document.querySelectorAll(this.closeAttribute);
    closeElements.forEach((element) => element.addEventListener('click', ThankScreenComingSoon.closeModal));

    // if the anchor element contains any events, bind them here.
    this.contactBuilderAnchor?.bindEvents?.()

    const detailsLink = this.contactBuilderAnchor?.getAnchor?.();
    detailsLink?.addEventListener('click', this.emitMoreDetailsClickEvent.bind(this));

    const closeBtn = this.getCloseBtn();
    closeBtn?.addEventListener('click', ()=> document.body.dispatchEvent(new CustomEvent('closeAnchorClick')));

    this.internalBrowsingAnchor?.bindEvents?.();
  }

  /**
   * Removes event listeners from the anchor element.
   * @function
   */
  unbindEvents() {
    const detailsLink = this.contactBuilderAnchor.getAnchor();
    detailsLink?.removeEventListener('click', this.emitMoreDetailsClickEvent);
  }

  /**
   * Closes the modal by clearing its HTML content.
   */
  static closeModal() {
    modalService.clearHtml();
  }

  /**
   * Gets the close button element by ID.
   * @returns {HTMLElement} The button element.
   */
  getCloseBtn() {
    return document.getElementById(this.closeBtnId);
  }

  getHtml() {
    return `
    <div class="lead-form form--thanks">
      <button id="${this.closeBtnId}" class="modal__close" data-close>
        ${closeModalSvg}          
      </button>
      <div class="thanks__content">
        ${thankYouSuccess}
        <p class="thanks__title">Way to Go!</p>
        <p class="thanks__text" data-qa="firstmsg">
          You're connected with ${this.builderName}.<br> 
          The best way to find out more is to visit the community yourself!
        </p>
      </div>
      <div class="thanks__footer">
        <p class="thanks__footer-title">What’s Next?</p>
        <div class="thanks__footer-container">
          <p class="thanks__footer-text" data-qa="ThankYouEmail">${thankYouEmail} We’ll email you the info about the communities you’re interested in</p>
          <p class="thanks__footer-text" data-qa="ThankYouPhone">${thankYouPhone} Builders will reach out to answer any questions you may have</p>
          <p class="thanks__footer-text" data-qa="ThankYouHeart">${thankYouHeart} Your preferences are now saved for future requests</p>
        </div>
        <div class="thanks__progress" data-qa="ThanksProgress"></div>
      </div>
      <div class="form__button-bar">
        ${this.internalBrowsingAnchor.getHtml()}
        ${this.contactBuilderAnchor.getHtml()}
      </div>
    </div>`;
  }
}
